/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_FailedInputs */

const en_settings_apikeys_failed = /** @type {(inputs: Settings_Apikeys_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create key`)
};

/**
* | output |
* | --- |
* | "Failed to create key" |
*
* @param {Settings_Apikeys_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_failed = /** @type {((inputs?: Settings_Apikeys_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_failed(inputs)
});
export { settings_apikeys_failed as "settings.apikeys.failed" }